import { AxiosRequestConfig } from "axios";

const frontApiRequestTransformer = () => {
    return async (requestConfig: AxiosRequestConfig) => {
        return requestConfig;
    };
};

export default frontApiRequestTransformer;
